export default __webpack_public_path__ + "static/media/image.9d319054.svg";